import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Android SDK captures anonymous events by default. However, this may change depending on your `}<inlineCode parentName="p">{`personProfiles`}</inlineCode>{` `}<a parentName="p" {...{
        "href": "/docs/libraries/android#all-configuration-options"
      }}>{`config`}</a>{` when initializing PostHog:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`personProfiles = PersonProfiles.IDENTIFIED_ONLY`}</inlineCode>{` `}<em parentName="p">{`(recommended)`}</em>{` `}<em parentName="p">{`(default)`}</em>{` - Anonymous events are captured by default. PostHog only captures identified events for users where `}<a parentName="p" {...{
            "href": "/docs/data/persons"
          }}>{`person profiles`}</a>{` have already been created.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`personProfiles = PersonProfiles.ALWAYS`}</inlineCode>{` - Capture identified events for all events.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`personProfiles = PersonProfiles.NEVER`}</inlineCode>{` - Capture anonymous events for all events.`}</p>
      </li>
    </ol>
    <p>{`For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`val config = PostHogAndroidConfig(
   apiKey = POSTHOG_API_KEY,
   host = POSTHOG_HOST,
).apply {
   personProfiles = PersonProfiles.IDENTIFIED_ONLY
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      